import axios from "axios";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";

const getAllFacility = async (params: any) => {
  const url = endpoints.VIEW_LIST_FACILITY;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params: params,
  });

  return response;
};

const getFacilityById = async (id: number) => {
  const url = endpoints.VIEW_LIST_FACILITY + "/" + id;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const createFacility = async (params: any) => {
  const url = endpoints.VIEW_LIST_FACILITY;

  const { data: response } = await axios.post(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const updateFacility = async (params: any) => {
  const url = endpoints.VIEW_LIST_FACILITY + "/" + params.id;

  const { data: response } = await axios.put(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const deleteFacility = async (id: number) => {
  const url = endpoints.VIEW_LIST_FACILITY + "/" + id;

  const { data: response } = await axios.delete(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const facilityService = {
  getAllFacility,
  createFacility,
  updateFacility,
  deleteFacility,
  getFacilityById,
};

export default facilityService;
